import { useMemo, useState } from 'react';
import { createPortal } from 'react-dom';
import { Modal, Skeleton, useMediaQuery } from '@mui/material';
import { Close } from '@mui/icons-material';
import clsx from 'clsx';
import style from './style.module.scss';
import { __ } from '../../../shared/tools';

export const ProductDeclinaisons = ({ product }) => {
    const { declinaisons } = product;
    const [modalOpen, setModalOpen] = useState(false);
    const isLaptop = useMediaQuery(`(max-width:${style.laptopBreakpoint}) and (min-width:${style.mobileBreakpoint})`);
    const isPhone = useMediaQuery(`(max-width:${style.mobileBreakpoint})`);

    const handleOpen = () => {
        setModalOpen(true);
    };

    const handleClose = () => {
        setModalOpen(false);
    };

    const nbDisplayed = useMemo(() => {
        return isLaptop ? 4 : isPhone ? 3 : 6;
    }, [isLaptop, isPhone]);

    return declinaisons.length > 1 ? (
        <div className={style.declinaisons}>
            <p className={style.subtitle}>{__('Autres coloris')}</p>
            <ul className={style.list}>
                {declinaisons.map((declinaison, index) => {
                    if (index + 1 > nbDisplayed) return null;
                    return (
                        <li key={declinaison.id} className={clsx(style.item, declinaison.active && style.active)}>
                            {index + 1 === nbDisplayed && declinaisons.length > nbDisplayed ? (
                                <button className={style.button} onClick={handleOpen}>
                                    {declinaison.image && (
                                        <img src={declinaison.image} alt={declinaison.name} className={style.image} />
                                    )}
                                    {declinaisons.length - nbDisplayed > 0 && (
                                        <span>+{declinaisons.length - nbDisplayed}</span>
                                    )}
                                </button>
                            ) : (
                                <ProductDeclinaison product={declinaison} />
                            )}
                        </li>
                    );
                })}
            </ul>
            {createPortal(
                <ProductDeclinaisonsModal product={product} open={modalOpen} onClose={handleClose} />,
                document.body,
            )}
        </div>
    ) : null;
};

const ProductDeclinaisonsModal = ({ product, open, onClose }) => {
    const { name, declinaisons } = product;

    return (
        <Modal className={style.modal} open={open} onClose={onClose}>
            <aside className={style.aside}>
                <div className={style.header}>
                    <p className={style.title}>{name}</p>
                    <Close className={style.close} onClick={onClose} />
                </div>
                <ul className={style.list}>
                    {declinaisons.map((declinaison) => (
                        <li key={declinaison.id} className={style.item}>
                            <ProductDeclinaison product={declinaison} />
                        </li>
                    ))}
                </ul>
            </aside>
        </Modal>
    );
};

const ProductDeclinaison = ({ product }) => {
    const [loading, setLoading] = useState(true);
    const handleLoad = () => setLoading(false);

    return (
        <a href={product.url}>
            {product.image && (
                <img src={product.image} alt={product.name} className={style.image} onLoad={handleLoad} />
            )}
            {loading && <Skeleton variant="rectangular" className={clsx(style.image, style.skeleton)} />}
            <span>{product.name}</span>
        </a>
    );
};
